"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queryListSectionClasses = void 0;
var _mui = require("@ori-ui/mui");
const queryListSectionClasses = exports.queryListSectionClasses = (0, _mui.generateUtilityClasses)('QueryListSection', ['root', 'sectionLabel', 'queries', 'query']);
